import { render, staticRenderFns } from "./RotatePetals.vue?vue&type=template&id=19474389&scoped=true&"
import script from "./RotatePetals.vue?vue&type=script&lang=js&"
export * from "./RotatePetals.vue?vue&type=script&lang=js&"
import style0 from "./RotatePetals.vue?vue&type=style&index=0&id=19474389&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19474389",
  null
  
)

export default component.exports